import { FLAGS_MAP } from '@guestyci/arc/flags/registry';

const CALLING_CODES = {
  US: '1',
  AG: '1',
  AI: '1',
  AS: '1',
  BB: '1',
  BM: '1',
  BS: '1',
  CA: '1',
  DM: '1',
  DO: '1',
  GD: '1',
  GU: '1',
  JM: '1',
  KN: '1',
  KY: '1',
  LC: '1',
  MP: '1',
  MS: '1',
  PR: '1',
  SX: '1',
  TC: '1',
  TT: '1',
  VC: '1',
  VG: '1',
  VI: '1',
  UM: '1',
  RU: '7',
  KZ: '7',
  EG: '20',
  ZA: '27',
  GR: '30',
  NL: '31',
  BE: '32',
  FR: '33',
  ES: '34',
  HU: '36',
  IT: '39',
  VA: '39',
  RO: '40',
  CH: '41',
  AT: '43',
  GB: '44',
  GG: '44',
  IM: '44',
  JE: '44',
  DK: '45',
  SE: '46',
  NO: '47',
  SJ: '47',
  PL: '48',
  DE: '49',
  PE: '51',
  MX: '52',
  CU: '53',
  AR: '54',
  BR: '55',
  CL: '56',
  CO: '57',
  VE: '58',
  MY: '60',
  AU: '61',
  CC: '61',
  CX: '61',
  ID: '62',
  PH: '63',
  NZ: '64',
  PN: '64',
  SG: '65',
  TH: '66',
  JP: '81',
  KR: '82',
  VN: '84',
  CN: '86',
  TR: '90',
  IN: '91',
  PK: '92',
  AF: '93',
  LK: '94',
  MM: '95',
  IR: '98',
  SS: '211',
  MA: '212',
  EH: '212',
  DZ: '213',
  TN: '216',
  LY: '218',
  GM: '220',
  SN: '221',
  MR: '222',
  ML: '223',
  GN: '224',
  CI: '225',
  BF: '226',
  NE: '227',
  TG: '228',
  BJ: '229',
  MU: '230',
  LR: '231',
  SL: '232',
  GH: '233',
  NG: '234',
  TD: '235',
  CF: '236',
  CM: '237',
  CV: '238',
  ST: '239',
  GQ: '240',
  GA: '241',
  CG: '242',
  CD: '243',
  AO: '244',
  GW: '245',
  IO: '246',
  SC: '248',
  SD: '249',
  RW: '250',
  ET: '251',
  SO: '252',
  DJ: '253',
  KE: '254',
  TZ: '255',
  UG: '256',
  BI: '257',
  MZ: '258',
  ZM: '260',
  MG: '261',
  RE: '262',
  YT: '262',
  ZW: '263',
  NA: '264',
  MW: '265',
  LS: '266',
  BW: '267',
  SZ: '268',
  KM: '269',
  SH: '290',
  ER: '291',
  AW: '297',
  FO: '298',
  GL: '299',
  GI: '350',
  PT: '351',
  LU: '352',
  IE: '353',
  IS: '354',
  AL: '355',
  MT: '356',
  CY: '357',
  FI: '358',
  AX: '358',
  BG: '359',
  LT: '370',
  LV: '371',
  EE: '372',
  MD: '373',
  AM: '374',
  BY: '375',
  AD: '376',
  MC: '377',
  SM: '378',
  UA: '380',
  RS: '381',
  ME: '382',
  XK: '383',
  HR: '385',
  SI: '386',
  BA: '387',
  MK: '389',
  CZ: '420',
  SK: '421',
  LI: '423',
  FK: '500',
  GS: '500',
  BZ: '501',
  GT: '502',
  SV: '503',
  HN: '504',
  NI: '505',
  CR: '506',
  PA: '507',
  PM: '508',
  HT: '509',
  GP: '590',
  BL: '590',
  MF: '590',
  BO: '591',
  GY: '592',
  EC: '593',
  GF: '594',
  PY: '595',
  MQ: '596',
  SR: '597',
  UY: '598',
  CW: '599',
  BQ: '599',
  AN: '599',
  TL: '670',
  AQ: '672',
  NF: '672',
  BN: '673',
  NR: '674',
  PG: '675',
  TO: '676',
  SB: '677',
  VU: '678',
  FJ: '679',
  PW: '680',
  WF: '681',
  CK: '682',
  NU: '683',
  WS: '685',
  KI: '686',
  NC: '687',
  TV: '688',
  PF: '689',
  TK: '690',
  FM: '691',
  MH: '692',
  KP: '850',
  HK: '852',
  MO: '853',
  KH: '855',
  LA: '856',
  BD: '880',
  TW: '886',
  MV: '960',
  LB: '961',
  JO: '962',
  SY: '963',
  IQ: '964',
  KW: '965',
  SA: '966',
  YE: '967',
  OM: '968',
  PS: '970',
  AE: '971',
  IL: '972',
  BH: '973',
  QA: '974',
  BT: '975',
  MN: '976',
  NP: '977',
  TJ: '992',
  TM: '993',
  AZ: '994',
  GE: '995',
  KG: '996',
  UZ: '998',
};

const COUNTRY_NAMES = {
  AF: 'Afghanistan',
  AX: 'Åland Islands',
  AL: 'Albania',
  DZ: 'Algeria',
  AS: 'American Samoa',
  AD: 'Andorra',
  AO: 'Angola',
  AI: 'Anguilla',
  AQ: 'Antarctica',
  AG: 'Antigua and Barbuda',
  AR: 'Argentina',
  AM: 'Armenia',
  AW: 'Aruba',
  AU: 'Australia',
  AT: 'Austria',
  AZ: 'Azerbaijan',
  BS: 'Bahamas',
  BH: 'Bahrain',
  BD: 'Bangladesh',
  BB: 'Barbados',
  BY: 'Belarus',
  BE: 'Belgium',
  BZ: 'Belize',
  BJ: 'Benin',
  BM: 'Bermuda',
  BT: 'Bhutan',
  BO: 'Bolivia, Plurinational State of',
  BA: 'Bosnia and Herzegovina',
  BW: 'Botswana',
  BR: 'Brazil',
  IO: 'British Indian Ocean Territory',
  VG: 'Virgin Islands, British',
  BN: 'Brunei Darussalam',
  BG: 'Bulgaria',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  KH: 'Cambodia',
  CM: 'Cameroon',
  CA: 'Canada',
  CV: 'Cape Verde',
  KY: 'Cayman Islands',
  CF: 'Central African Republic',
  TD: 'Chad',
  CL: 'Chile',
  CN: 'China',
  CX: 'Christmas Island',
  CO: 'Colombia',
  KM: 'Comoros',
  CG: 'Congo',
  CK: 'Cook Islands',
  CR: 'Costa Rica',
  CI: "Côte d'Ivoire",
  HR: 'Croatia',
  CU: 'Cuba',
  CY: 'Cyprus',
  CZ: 'Czech Republic',
  CD: 'Congo, the Democratic Republic of the',
  DK: 'Denmark',
  DJ: 'Djibouti',
  DM: 'Dominica',
  DO: 'Dominican Republic',
  TL: 'Timor-Leste',
  EC: 'Ecuador',
  EG: 'Egypt',
  SV: 'El Salvador',
  GQ: 'Equatorial Guinea',
  ER: 'Eritrea',
  EE: 'Estonia',
  ET: 'Ethiopia',
  FK: 'Falkland Islands (Malvinas)',
  FO: 'Faroe Islands',
  FJ: 'Fiji',
  FI: 'Finland',
  FR: 'France',
  GF: 'French Guiana',
  PF: 'French Polynesia',
  GA: 'Gabon',
  GM: 'Gambia',
  GE: 'Georgia',
  DE: 'Germany',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GR: 'Greece',
  GL: 'Greenland',
  GD: 'Grenada',
  GP: 'Guadeloupe',
  GU: 'Guam',
  GT: 'Guatemala',
  GG: 'Guernsey',
  GN: 'Guinea',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HT: 'Haiti',
  HN: 'Honduras',
  HK: 'Hong Kong',
  HU: 'Hungary',
  IS: 'Iceland',
  IN: 'India',
  ID: 'Indonesia',
  IR: 'Iran, Islamic Republic of',
  IQ: 'Iraq',
  IE: 'Ireland',
  IL: 'Israel',
  IT: 'Italy',
  JM: 'Jamaica',
  JP: 'Japan',
  JE: 'Jersey',
  JO: 'Jordan',
  KZ: 'Kazakhstan',
  KE: 'Kenya',
  KI: 'Kiribati',
  KR: 'Korea, Republic of',
  XK: 'Kosovo, Republic of',
  KW: 'Kuwait',
  KG: 'Kyrgyzstan',
  LA: "Lao People's Democratic Republic",
  LV: 'Latvia',
  LB: 'Lebanon',
  LS: 'Lesotho',
  LR: 'Liberia',
  LY: 'Libya',
  LI: 'Liechtenstein',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  MO: 'Macao',
  MK: 'Macedonia, the former Yugoslav Republic of',
  MG: 'Madagascar',
  MW: 'Malawi',
  MY: 'Malaysia',
  MV: 'Maldives',
  ML: 'Mali',
  MT: 'Malta',
  MH: 'Marshall Islands',
  MQ: 'Martinique',
  MR: 'Mauritania',
  MU: 'Mauritius',
  YT: 'Mayotte',
  MX: 'Mexico',
  FM: 'Micronesia, Federated States of',
  MD: 'Moldova, Republic of',
  MC: 'Monaco',
  MN: 'Mongolia',
  ME: 'Montenegro',
  MS: 'Montserrat',
  MA: 'Morocco',
  MZ: 'Mozambique',
  MM: 'Myanmar',
  NA: 'Namibia',
  NR: 'Nauru',
  NP: 'Nepal',
  NL: 'Netherlands',
  AN: 'Netherlands Antilles',
  NC: 'New Caledonia',
  NZ: 'New Zealand',
  NI: 'Nicaragua',
  NE: 'Niger',
  NG: 'Nigeria',
  NU: 'Niue',
  NF: 'Norfolk Island',
  KP: "Korea, Democratic People's Republic of",
  MP: 'Northern Mariana Islands',
  NO: 'Norway',
  OM: 'Oman',
  PK: 'Pakistan',
  PW: 'Palau',
  PS: 'Palestine, State of',
  PA: 'Panama',
  PG: 'Papua New Guinea',
  PY: 'Paraguay',
  PE: 'Peru',
  PH: 'Philippines',
  PN: 'Pitcairn',
  PL: 'Poland',
  PT: 'Portugal',
  PR: 'Puerto Rico',
  QA: 'Qatar',
  RE: 'Réunion',
  RO: 'Romania',
  RU: 'Russian Federation',
  RW: 'Rwanda',
  SH: 'Saint Helena, Ascension and Tristan da Cunha',
  KN: 'Saint Kitts and Nevis',
  LC: 'Saint Lucia',
  PM: 'Saint Pierre and Miquelon',
  VC: 'Saint Vincent and the Grenadines',
  WS: 'Samoa',
  SM: 'San Marino',
  ST: 'São Tomé and Príncipe',
  SA: 'Saudi Arabia',
  SN: 'Senegal',
  RS: 'Serbia',
  SC: 'Seychelles',
  SL: 'Sierra Leone',
  SG: 'Singapore',
  SK: 'Slovakia',
  SI: 'Slovenia',
  SB: 'Solomon Islands',
  SO: 'Somalia',
  ZA: 'South Africa',
  GS: 'South Georgia and the South Sandwich Islands',
  SS: 'South Sudan',
  ES: 'Spain',
  LK: 'Sri Lanka',
  SD: 'Sudan',
  SR: 'Suriname',
  SJ: 'Svalbard and Jan Mayen',
  SZ: 'Swaziland',
  SE: 'Sweden',
  CH: 'Switzerland',
  SY: 'Syrian Arab Republic',
  TW: 'Taiwan',
  TJ: 'Tajikistan',
  TZ: 'Tanzania, United Republic of',
  TH: 'Thailand',
  TG: 'Togo',
  TK: 'Tokelau',
  TO: 'Tonga',
  TT: 'Trinidad and Tobago',
  TN: 'Tunisia',
  TR: 'Turkey',
  TM: 'Turkmenistan',
  TC: 'Turks and Caicos Islands',
  TV: 'Tuvalu',
  VI: 'Virgin Islands, U.S.',
  UG: 'Uganda',
  UA: 'Ukraine',
  AE: 'United Arab Emirates',
  GB: 'United Kingdom',
  US: 'United States',
  UM: 'United States Minor Outlying Islands',
  UY: 'Uruguay',
  UZ: 'Uzbekistan',
  VU: 'Vanuatu',
  VA: 'Holy See (Vatican City State)',
  VE: 'Venezuela, Bolivarian Republic of',
  VN: 'Viet Nam',
  WF: 'Wallis and Futuna',
  EH: 'Western Sahara',
  YE: 'Yemen',
  ZM: 'Zambia',
  ZW: 'Zimbabwe',
  BL: 'Saint Barthélemy',
  BQ: 'Bonaire, Sint Eustatius and Saba',
  CC: 'Cocos (Keeling) Islands',
  CW: 'Curaçao',
  IM: 'Isle of Man',
  MF: 'Saint Martin (French part)',
  SX: 'Sint Maarten (Dutch part)',
};

const EXCLUDED_COUNTRIES = new Set(['HM', 'BV', 'TF']);

const DISPLAY_NAME_OVERRIDES = {
  BO: 'Bolivia',
  CD: 'Congo, Democratic Republic of the',
  FK: 'Falkland Islands',
  FM: 'Federated States of Micronesia',
  IR: 'Iran',
  KP: 'North Korea',
  KR: 'South Korea',
  LA: 'Laos',
  MD: 'Moldova',
  MK: 'North Macedonia',
  PS: 'Palestine',
  RU: 'Russia',
  SH: 'Saint Helena',
  SY: 'Syria',
  TZ: 'Tanzania',
  VE: 'Venezuela',
  VN: 'Vietnam',
  XK: 'Kosovo',
};

const buildCountryList = () => {
  const entries = [];

  Object.keys(COUNTRY_NAMES).forEach(iso => {
    if (EXCLUDED_COUNTRIES.has(iso)) return;
    const callingCode = CALLING_CODES[iso];
    if (!callingCode) return;

    const flagEntry = FLAGS_MAP[iso.toLowerCase()];

    entries.push({
      iso,
      name: DISPLAY_NAME_OVERRIDES[iso] || COUNTRY_NAMES[iso],
      dialCode: `+${callingCode}`,
      FlagComponent: flagEntry?.Flag || null,
    });
  });

  entries.sort((a, b) => a.name.localeCompare(b.name));
  return entries;
};

export const COUNTRIES = buildCountryList();

export const DEFAULT_COUNTRY_ISO = 'US';

export const getCountryByIso = iso => COUNTRIES.find(c => c.iso === iso);

export const getCallingCodeForCountry = iso => {
  const code = CALLING_CODES[iso];
  return code ? `+${code}` : '';
};
